import enum_1 from "./enum_1.png";
import enum_2 from "./enum_2.png";
import enum_3 from "./enum_3.png";
import enum_4 from "./enum_4.png";
import enum_5 from "./enum_5.png";
import enum_6 from "./enum_6.png";
import enum_7 from "./enum_7.png";
import enum_8 from "./enum_8.png";
import enum_9 from "./enum_9.png";
import enum_10 from "./enum_10.png";
import enum_11_12 from "./enum_11_12.png";
import enum_13_14 from "./enum_13_14.png";
import enum_15 from "./enum_15.png"
import enum_16 from "./enum_16.png"
import enum_17 from "./enum_17.png"
import custom_doughnut from "./custom_doughnut.png";
import custom_horizontal_bar_graph from "./custom_horizontal_bar_graph.png";
import custom_line_graph from "./custom_line_graph.png";
import custom_pie from "./custom_pie.png";
import custom_vertical_bar_graph from "./custom_vertical_bar_graph.png";
import custom_stacked_bar_graph from "./custom_stacked_bar_graph.png";

export default {
  enum_1,
  enum_2,
  enum_3,
  enum_4,
  enum_5,
  enum_6,
  enum_7,
  enum_8,
  enum_9,
  enum_10,
  enum_11_12,
  enum_13_14,
  enum_15,
  enum_16,
  enum_17
};

export const CustomWidgetScreenshots = {
  custom_doughnut,
  custom_horizontal_bar_graph,
  custom_line_graph,
  custom_pie,
  custom_vertical_bar_graph,
  custom_stacked_bar_graph,
};
